import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ApplicationState } from '@/state/root.models'
import { ContributionsFilters, TransactionsFilters } from '../models'

import getAllTransactionsExtraReducer from '../thunks/get-all.thunk'
import getAllFreePlayContributionsExtraReducer from '../thunks/get-freeplay-contribution.thunk'
import initialState from './initial-state'

const transactionsSlice = createSlice({
  name: 'transaction',
  initialState,
  reducers: {
    setIsloadingAction: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setTransactionFiltersAction(
      state,
      action: PayloadAction<TransactionsFilters>,
    ) {
      state.filters = action.payload
    },
    setContributionsFiltersAction(
      state,
      action: PayloadAction<ContributionsFilters>,
    ) {
      state.contributionsFilters = action.payload
    },
    cleanContributionsAction(state) {
      state.contributions = initialState.contributions
      state.pagination = initialState.pagination
    },
    cleanTransactionsAction(state) {
      state.transactions = initialState.transactions
      state.pagination = initialState.pagination
    },
  },
  extraReducers: (builder) => {
    getAllTransactionsExtraReducer(builder)
    getAllFreePlayContributionsExtraReducer(builder)
  },
})

export const TransactionsActions = transactionsSlice.actions

export const transactionsSelector = ({ transaction }: ApplicationState) =>
  transaction

export default transactionsSlice
